<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>


        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="questionDesc" id="questionDesc" type="text" pInputText>
            <label for="questionDesc">Question Description</label>
            @for (validation of validationMessages.questionDesc; track validation) {
              <span>
                @if (form1.get('questionDesc').hasError(validation.type) && (form1.get('questionDesc').dirty || form1.get('questionDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="answerDesc" id="answerDesc" type="text" pInputText>
            <label for="answerDesc">Answer Description</label>
            @for (validation of validationMessages.answerDesc; track validation) {
              <span>
                @if (form1.get('answerDesc').hasError(validation.type) && (form1.get('answerDesc').dirty || form1.get('answerDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="category" id="category" type="text" pInputText>
            <label for="category">category</label>
            @for (validation of validationMessages.category; track validation) {
              <span>
                @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="section" id="section" type="text" pInputText>
            <label for="section">Section</label>
            @for (validation of validationMessages.section; track validation) {
              <span>
                @if (form1.get('section').hasError(validation.type) && (form1.get('section').dirty || form1.get('section').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="website" id="website" type="text" pInputText>
            <label for="website">Website</label>
            @for (validation of validationMessages.website; track validation) {
              <span>
                @if (form1.get('website').hasError(validation.type) && (form1.get('website').dirty || form1.get('website').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (questionAnswerId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete QuestionAnswer</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!questionAnswerId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add QuestionAnswer</button>
              }

              @if (questionAnswerId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update QuestionAnswer</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>